import Typography from '@material-ui/core/Typography';
import React from 'react';
import Link from '@material-ui/core/Link';


class QuickLinks extends React.Component {
    render() {
        return (
            <div className="card">
                <div className="card-header">
                    <div className="col-2 font-weight-bold">Quick Links</div>
                </div>
                <div className="card-body">
                    <Typography paragraph gutterBottom={true}>
                        <Link replace href="/Administration/new">Apply for New Entrance Permit</Link>
                    </Typography>
                </div>
            </div>
        );
    }
}

export default QuickLinks;
